import config from 'config'
import {
} from 'containers/pages'
import { Main } from 'components/masters'
import { get } from 'lodash'
import React from 'react'
import { Tabs } from 'components/layout'
import * as Page from 'containers/pages'

const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/my-tasks`,
    component: props => (
      <Main params={get(props, 'match.params', {})} {...props}>
        <Page.Tasks
          params={get(props, 'match.params', {})}
          tabs={
            <Tabs params={get(props, 'match.params', {})} {...props} />
          }
          decoFilterMyOnly
          {...props}
        />
      </Main>
    ),
    routes: [
      {
        path: `${publicPath}/my-tasks/registration-participants`,
        exact: true,
        component: props => (
          <Page.TasksRegistrationParticipants decoFilterMyOnly {...props} />
        )
      },
      {
        path: `${publicPath}/my-tasks/section-approval`,
        exact: true,
        component: props => (
          <Page.TasksActivityApproval decoFilterMyOnly {...props} />
        )
      },
      {
        path: `${publicPath}/my-tasks/section-signoff`,
        exact: true,
        component: props => (
          <Page.TasksSectionSignoff decoFilterMyOnly {...props} />
        )
      },
      {
        path: `${publicPath}/my-tasks/adventurous-journey`,
        exact: true,
        component: props => (
          <Page.TasksAdventurousJourney decoFilterMyOnly {...props} />
        )
      },
      {
        path: `${publicPath}/my-tasks/award-signoff`,
        exact: true,
        component: props => (
          <Page.TasksAwardSignoff decoFilterMyOnly {...props} />
        )
      },
      {
        path: `${publicPath}/my-tasks/unassigned-participants`,
        exact: true,
        component: props => (
          <Page.TasksUnassignedParticipants decoFilterMyOnly {...props} />
        )
      },
      {
        path: `${publicPath}/my-tasks/email-revision`,
        exact: true,
        component: props => (
          <Page.TasksEmailRevision decoFilterMyOnly {...props} />
        )
      },
      {
        path: `${publicPath}/my-tasks/assessors`,
        exact: true,
        component: props => (
          <Page.TasksAssessors decoFilterMyOnly {...props} />
        )
      },
      {
        path: `${publicPath}/my-tasks/assessors-activity`,
        exact: true,
        component: props => (
           <Page.TasksAssessorsActivityCategoryRegistrations decoFilterMyOnly {...props} />
        )
      },
      {
        path: `${publicPath}/my-tasks/wwc-update`,
        exact: true,
        component: props => (
            <Page.TasksWWCUpdate decoFilterMyOnly {...props} />
        )
      },
    ]
  }
]

export default routes
